import React, { useState } from "react";
import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import CategoryGridItem from "./CategoryGridItem";

const Categories = (props) => {
  const categories = useSelector(
    ({ configReducer }) => configReducer.fullCategoryList,
  );
  const [activeCat, setActiveCat] = useState(null);
  const { sharingTemplates, navigation } = props;

  return (
    <View
      style={[styles.categoriesWrapper, { paddingTop: 6, paddingBottom: 20 }]}
    >
      <View>
        {Array.isArray(categories) &&
          categories.map((item, index) => {
            return (
              <CategoryGridItem
                activeCat={activeCat}
                setActiveCat={setActiveCat}
                key={item.c_id}
                item={item}
                sharingTemplates={sharingTemplates}
                navigation={navigation}
              />
            );
          })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  categoriesWrapper: {},
});

export default Categories;
